import React from 'react';
import { GlobalStyles,Container,Box,Paper,Typography,Grid,Stack,TextField,MenuItem,Button } from '@mui/material';
import {useNavigate} from 'react-router-dom';

import * as yup from 'yup';
import {Form, useFormik} from 'formik';
import firebase from "../../firebase/firebase";
import Portal from "@mui/material/Portal";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import AlertDialog from '../../components/AlertDialog';

function SelectYourLocation() {
    const formikCreator = useFormik({
        initialValues: {
          country:'',
          email:'',
          
        },
        validationSchema: yup.object().shape({
          country: yup.string().required('Please select your country'),
           email:  yup.string().required(<AlertDialog open={true} title={"You cannot move forward yet"} message={"You cannot move forward before inserting your location and email."} btn_Orange_Text={"Go back"}/>).email(),

        }),
      onSubmit:async (values) => {
          const {email, country} = values

        const otherCountries = firebase.firestore().collection('other_countries');
        try {
          const post= await otherCountries.add({
            email,
            country,
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          })
          setSelected('')
          formikCreator.resetForm()
          setOpen(true)
        } catch (e){

        }
      }


    })
    const [selected,setSelected]=React.useState('');
    const [open, setOpen] = React.useState(false)
    const navigator = useNavigate()
    const handleClose = () => setOpen(false);
    return (
   <React.Fragment>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* TopBar */}
      {/* <TopBar/> */}
      <Container  maxWidth="md" component="main" sx={{ mt: 10, mb:8, display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection:'column', }} >
                              <Grid
                  item
                  xs={10}
                  sm={10}
                  md={5}
                  ml={10}
                >
          <Typography variant="h4" fontWeight={400} fontSize={'28px'} fontStyle="bold"  color="text.primary" component="h4" >
            Select  your  <font color="#204488">Location</font>
            {/*{messages?.joinNow?.who_are_you?.pageTitle}*/}
          </Typography>
          </Grid>
       </Container>
       <Container maxWidth="md" component="main" sx={{mb:15}}>
                <Grid container spacing={19}>
                <Grid
                  item
                  xs={10}
                  sm={10}
                  md={5}
                  ml={10}
                >
                            <Paper elevation={4} >
                            <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection:'column',
                            mb: 2,
                            pb: 4,


                            height: 87, backgroundColor:  `${selected !== 'United States' ? '#ffffff': '#204488'}`  , borderRadius: '10px'
                            }}
                                onClick={() => setSelected('United States')}>
                            <div style={{width: '90%', alignContent:"left",justifyContent:"left", color:  `${selected === 'United States' ? '#ffffff': '#204488'}`, position:'relative', top: 30,right:85}}>
                                <img src={'/assets/UnitedStates.png'} height={40} alt='unitedstates' />
                            </div>
                            <Typography  variant="body1"  component="p" color={selected === 'United States' ? '#ffffff': '#204488'} textAlign={"center"} fontWeight="400" sx={{width:"140px",marginTop:"-10px",ml:4}} >
                                United States
                            </Typography>
                            {/*`${tier.id !== selected ? '#ffffff': '#204488' }`*/}

                            </Box>
                        </Paper>      
                        </Grid>
                        <Grid
                            item
                            xs={10}
                            sm={10}
                            md={5}
                            ml={10}
                            
                        >
                            <Paper elevation={4} >
                            <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection:'column',
                            mb: 2,
                            pb:4,
                            
                            height: 87, backgroundColor:  `${selected !== '   Other Location' ? '#ffffff': '#204488'}`  , borderRadius: '10px'
                            }}
                                onClick={() => setSelected('   Other Location')}>
                        <div style={{width: '90%', alignContent:"left",justifyContent:"left", color:  `${selected === '   Other Location' ? '#ffffff': '#204488'}`, position:'relative', top: 30,right:85}}>
                                <img src={'/assets/OtherCountries.png'} height={40} alt='   Other Location'/>
                            </div>
                            <Typography  variant="body1"  component="p" color={selected === '   Other Location' ? '#ffffff': '#204488'} textAlign={"center"} fontWeight="400" sx={{width:"140px",marginTop:"-10px",ml:5}}>
                             Other Location
                            </Typography>
                            {/*`${tier.id !== selected ? '#ffffff': '#204488' }`*/}

                            </Box>
                        </Paper>      
                        </Grid> 
                    </Grid>
        </Container>
        {selected==="   Other Location" &&<>
        <Container  maxWidth="md" component="main" sx={{  mb:8, display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection:'column',
                            mt:-10
                            }}>
          <Typography sx={{mr:8}}
          variant="body1" fontWeight={400} fontSize={"16px"} align="left" color="text.primary" component="p" >
          Please note that our platform is only available in the United States at the moment. <br/>
            Insert your location and email so we can notify you once we expand to other locations.
            {/*{messages?.joinNow?.who_are_you?.pageTitle}*/}
          </Typography>
       </Container>

       <Container   maxWidth="md" component="main" sx={{ mt: -4, mb:10 }} compnent={'form'}>
        <form onSubmit={formikCreator.handleSubmit}>
          <Grid  container spacing={2}  >
            <Grid item xs={12}>
              <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 2,
                flexDirection:'column',
                ml:14.5
              }}
              > 
                <Grid container spacing={2}>

                  <Grid   item xs={12}>

                    <TextField
                      select
                      value={formikCreator.values.country}
                      onChange={formikCreator.handleChange}
                      error={formikCreator.touched.country && Boolean(formikCreator.errors.country)}
                      helperText={formikCreator.touched.country && formikCreator.errors.country}
                      name='country'
                      label={'Select Country'} variant="outlined" 
                      sx={{width:'100%',  textAlign: 'left',ml:-10}}>
                      <MenuItem value={'China'}>China</MenuItem>
                      <MenuItem value={'Europe'}>Europe</MenuItem>
                      <MenuItem value={'India'}>India</MenuItem>
                      <MenuItem value={'South Korea'}>South Korea</MenuItem>
                      <MenuItem value={'Others'}>Others</MenuItem>
                      <MenuItem value={'United Kingdom'}>United Kingdom </MenuItem>
                    </TextField>


                  </Grid>
                  <Grid   item xs={12}>
                    <TextField
                      name="email"
                      label={ "Email*"}
                      value={formikCreator.values.email}
                      onChange={formikCreator.handleChange}
                      error={formikCreator.touched.email && Boolean(formikCreator.errors.email)}
                      helperText={formikCreator.touched.email && formikCreator.errors.email}
                      variant="outlined" sx={{width:'100%',ml:-10}} type="email"/>
                  </Grid>

                </Grid>

              </Box>
            </Grid>
          </Grid>
          <Grid
                  item
                  xs={10}
                  sm={10}
                  md={5}
                  ml={15}
                >
          <Stack spacing={5} direction="row" sx={{
            alignItems:"center",justifyContent:"center",marginRight:"5%", mt: 5 

          }}>

            <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, textTransform:'uppercase',mb:5,alignItems:"center",justifyContent:"center"}}   type='submit'>Next</Button>
          </Stack>
          </Grid>
        </form>

       </Container>

        </>

        }
     {selected !=="   Other Location" &&
       <Container  maxWidth="md"  component="main" >
        <Grid
                  item
                 
                >
         <Stack  direction="row" 
       
         sx={{
           alignItems: 'center',
           pb: 20,
           justifyContent:'center',
           ml:7
           
        
         }}>
          
      
           

           <Stack direction="column">
           <Button variant="contained"

            sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, textTransform:'uppercase',mb:5,alignItems:"center",justifyContent:"center"}}  disabled={!selected}  type='submit' onClick={() =>navigator('/auth/who-are-you')}>Next</Button>
           </Stack>
          

         </Stack>
         </Grid>
       </Container>
        }


     <Portal>
       <div>

         <Dialog
           open={open}
           onClose={handleClose}
           fullWidth={true}
           maxWidth={'lg'}
           aria-labelledby="alert-dialog-title"
           aria-describedby="alert-dialog-description"
           sx={{textAlign: 'center'}}
         >
           <DialogTitle id="alert-dialog-title" color={'primary'} sx={{py: 3}}>
             You cannot move forward Yet
           </DialogTitle>
           <DialogContent>
             <DialogContentText id="alert-dialog-description">
               Unfortunately Taost is not available in your location yet. You will be notified once our platform is available in your location.


             </DialogContentText>
             <Button onClick={()=> {
               handleClose();

             }} variant={'contained'}  sx={{px: 5,marginY: 3 }}>
               OKAY
             </Button>
           </DialogContent>
         </Dialog>
       </div>
     </Portal>
   </React.Fragment>
  )
}

export default SelectYourLocation